<template>
  <div>
    <div class="ma-0 ma-sm-2">
      <v-card :loading="loading" flat class="blueCard mb-6">
        <v-card-title class="d-flex flex-row align-center">
          <div class="text-h4 mr-4">Popular Contact Lens Care Products</div>

          <v-spacer class="d-none d-sm-flex"></v-spacer>
          <div class="filterInput">
            <v-text-field
              v-model="search"
              append-icon="mdi-filter"
              label="Filter"
              outlined
              hide-details
              dense
              clearable
              @keyup="enteredSearchVal()"
            />
          </div>
        </v-card-title>
        <v-card-text>
          <div>
            <v-btn
              v-if="catNames"
              class="mx-2"
              :class="{ activeToggle: !catSearch }"
              @click="
                search = null;
                catSearch = null;
              "
              small
              text
              color="primary"
              >All</v-btn
            >
            <v-btn
              v-for="catName in catNames"
              :key="catName"
              @click="
                search = null;
                catSearch = catName;
              "
              class="mx-2"
              :class="{ activeToggle: catSearch == catName }"
              small
              text
              color="primary"
            >
              <span v-if="titlesForCategories[catName]">{{
                titlesForCategories[catName]
              }}</span>
              <span v-else>{{ catName | titleize }}</span></v-btn
            >
          </div>
        </v-card-text>
      </v-card>

      <v-slide-y-transition>
        <div class="caption" v-if="search || catSearch">
          Filtering products for
          <span v-if="search">"{{ search }}"</span>
          <span v-if="search && catSearch">and</span>
          <span v-if="catSearch">"{{ titlesForCategories[catSearch] }}"</span>
          <v-btn
            text
            x-small
            color="red"
            @click="
              search = null;
              catSearch = null;
            "
            >Clear Filters</v-btn
          >
        </div>
      </v-slide-y-transition>
      <div
        v-for="(catItems, catName) in filteredItemsByCategory"
        :key="catName"
      >
        <v-divider class="my-2"></v-divider>
        <div class="text-h5 mt-4 mb-2 categoryClass" :id="catName">
          <span v-if="titlesForCategories[catName]">{{
            titlesForCategories[catName]
          }}</span>
          <span v-else>{{ catName | titleize }}</span>
        </div>

        <v-card
          v-for="catItem in catItems"
          :key="`${catItem.slug}_${catName}`"
          flat
          style="background-color: #f5f5f5; border: 1px solid #e0e0e0"
          class="d-flex flex-row my-4 width100p"
          :id="catItem.slug"
        >
          <div>
            <div style="width: 120px">
              <v-img
                v-if="catItem.image"
                :src="'http://www.eyedock.com/' + catItem.image"
                contain
                max-height="130"
                class="ma-3"
              ></v-img>
            </div>
          </div>

          <div class="mx-2">
            <div class="d-sm-flex flex-row flex-wrap align-center">
              <div class="title mr-sm-4">{{ catItem.name }}</div>

              <div v-if="catItem.company" class="caption">
                <span v-if="catItem.url">
                  (<a :href="catItem.url" target="_blank"
                    >{{ catItem.company }}
                    <v-icon x-small color="primary" class="ml-1"
                      >mdi-open-in-new</v-icon
                    ></a
                  >)</span
                >
                <span v-else>({{ catItem.company }})</span>
              </div>
            </div>

            <div class="body-2 mt-2" v-if="catItem.moreInfo">
              <vue-markdown>{{ catItem.moreInfo }}</vue-markdown>
            </div>
          </div>
        </v-card>
      </div>
      <!-- {{ categories }}<br />
      {{ items }} -->
    </div>
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";
import VueMarkdown from "@adapttive/vue-markdown";

export default {
  name: "ClProducts",
  components: {
    VueMarkdown,
  },
  props: {},
  data: function () {
    return {
      loading: false,
      slug: null,
      items: null,
      categories: null,
      search: null,
      catSearch: null,
      titlesForCategories: {
        rgp_cleaning: "GP/Scleral Solutions",
        scleral_filling: "Scleral Filling Solutions",
        rgp_protein_remover: "RGP Protein Removers",
        scl_cleaning: "Soft Lens Solutions",
      },
    };
  },
  methods: {
    enteredSearchVal() {
      if (this.search) this.catSearch = null;
    },
    callApi() {
      this.loading = true;

      ApiServices.genericApiCall("/references/cl_products")
        .then((response) => {
          this.items = response.data.items;
          this.categories = response.data.meta?.categories;
          this.checkSlug();
        })
        .catch((error) => {
          console.log("error", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    checkSlug() {
      if (this.slug) {
        // alert("slug is " + this.slug);
        this.$nextTick(() => {
          this.$vuetify.goTo("#" + this.slug, { offset: 20 });
        });
      }
    },
  },
  computed: {
    filteredItemsByCategory() {
      if (!this.items) return null;
      let rtn = {};
      this.items.forEach((item) => {
        if (this.catSearch && item.category != this.catSearch) return;
        if (this.search) {
          if (
            !item.name.toLowerCase().includes(this.search.toLowerCase()) &&
            !item.company.toLowerCase().includes(this.search.toLowerCase()) &&
            !item.slug.toLowerCase().includes(this.search.toLowerCase()) &&
            !item.category.toLowerCase().includes(this.search.toLowerCase())
          )
            return;
        }
        if (!rtn[item.category]) rtn[item.category] = [];
        rtn[item.category].push(item);
      });
      return rtn;
    },
    catNames() {
      if (!this.categories) return null;
      let names = Object.keys(this.categories);
      return names;
    },
  },
  watch: {
    // search(val) {
    //   if (val) this.catSearch = null;
    // },
  },
  mounted() {
    this.callApi();
    this.slug = this.$route?.params?.slug ?? null;
  },
};
</script>

<style scoped>
.filterInput {
  max-width: 250px;
}
</style>
